// Module
var code = `<div class="page-content investors">
<!--    <a class="breadcrumbs" href="/investors/faqs" data-channel="ROUTE" data-event-prevent-default="true" data-page-id="investors" data-section="faqs">Investor FAQs</a>-->
  <div id="code-container"></div>
</div>
`;
// Exports
module.exports = code;